const SENSITIVE_EXTENSIONS = new Set(['csv', 'xls', 'xlsx', 'json', 'xml'])

export const isSensitiveFile = fileName => {
  if (!fileName) return false
  const ext = fileName
    .split('.')
    .pop()
    .toLowerCase()
  return SENSITIVE_EXTENSIONS.has(ext)
}

export const formatFileSize = bytes => {
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }
  return `${Math.round(bytes / 1024)} KB`
}

export const formatDate = isoString => {
  return new Date(isoString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export const triggerDownload = (url, fileName) => {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
